import * as actions from './actions'
import * as appAPIs from '../api/appAPIs'
import { store } from '../store/index'
import * as configApi from '../api/config'

export {
  initialApp,
  changeLanguage,
  checkGeoBlocking,
  getMuxEnvKey,
  getRegionSubcription,
}

function initialApp() {
  return dispatch => {
    dispatch(actions.initialApp())
  }
}

function changeLanguage(value) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(actions.changeLanguage(value))
      resolve()
    })
  }
}

function checkGeoBlocking() {
  return dispatch => {
    return Promise.resolve()
  }

  const { isBlock } = store.getState().root
  return dispatch => {
    return new Promise((resolve, reject) => {
      appAPIs
        .allowedCountries()
        .then(response => {
          if (isBlock) {
            dispatch(actions.isBlockCountries(false))
          }
          resolve(response)
        })
        .catch(error => {
          if (error.message === 'country_blocking_exception') {
            dispatch(actions.isBlockCountries(true))
          }
          reject(error)
        })
    })
  }
}

function getMuxEnvKey() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      configApi
        .getMuxEnvKey()
        .then(response => {
          dispatch(actions.updateMuxKey(response.results))
          resolve(response)
        })
        .catch(errors => {
          reject(errors)
        })
    })
  }
}

function getRegionSubcription() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      configApi
        .getRegionSubcription()
        .then(response => {
          dispatch(actions.updateRegionSubcription(true))
          resolve(response)
        })
        .catch(errors => {
          dispatch(actions.updateRegionSubcription(false))
          reject(errors)
        })
    })
  }
}
